var _dec, _class, _FormFieldMessage, _IconWarningSolid;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { IconWarningSolid } from '@instructure/ui-icons';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { propTypes, allowedProps } from './props';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
---
parent: FormField
---

This is a helper component that is used by most of the custom form
components. In most cases it shouldn't be used directly.

```js
---
type: example
---
<FormFieldMessage variant="error">Invalid value</FormFieldMessage>
```
**/
let FormFieldMessage = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_FormFieldMessage = class FormFieldMessage extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      this.ref = el;
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  render() {
    const _this$props3 = this.props,
      children = _this$props3.children,
      styles = _this$props3.styles;
    return this.props.variant !== 'screenreader-only' ? _jsxs("span", {
      css: {
        display: 'flex'
      },
      children: [this.props.variant === 'newError' && this.props.children && _jsx("span", {
        css: styles === null || styles === void 0 ? void 0 : styles.errorIcon,
        children: _IconWarningSolid || (_IconWarningSolid = _jsx(IconWarningSolid, {
          color: "error"
        }))
      }), _jsx("span", {
        css: styles === null || styles === void 0 ? void 0 : styles.formFieldMessage,
        ref: this.handleRef,
        children: children
      })]
    }) : _jsx(ScreenReaderContent, {
      elementRef: this.handleRef,
      children: children
    });
  }
}, _FormFieldMessage.displayName = "FormFieldMessage", _FormFieldMessage.componentId = 'FormFieldMessage', _FormFieldMessage.propTypes = propTypes, _FormFieldMessage.allowedProps = allowedProps, _FormFieldMessage.defaultProps = {
  variant: 'hint'
}, _FormFieldMessage)) || _class);
export default FormFieldMessage;
export { FormFieldMessage };